import { render, staticRenderFns } from "./ICMORelease.vue?vue&type=template&id=555d677f&scoped=true&"
import script from "./ICMORelease.vue?vue&type=script&lang=js&"
export * from "./ICMORelease.vue?vue&type=script&lang=js&"
import style0 from "./ICMORelease.vue?vue&type=style&index=0&id=555d677f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555d677f",
  null
  
)

export default component.exports